import {AvailablePaginationSize} from '../types/available-pagination-size.type';

export interface PageableResponse<T> {
  content: T[];
  pageable: {
    pageNumber: number,
    pageSize: number,
    sort: {
      sorted: boolean,
      unsorted: boolean
    };
  };
  totalElements: number;
  totalPages: number;
  last: boolean;
  first: boolean;
  size: AvailablePaginationSize;
  number: number;
  numberOfElements: number;
  empty: boolean;
}

export class Page<T> {
  constructor(
    public content: T[],
    public totalElements: number,
    public totalPages: number,
    public number: number,
    public size: AvailablePaginationSize,
    public first: boolean,
    public last: boolean,
    public empty: boolean
  ) {
  }

  public static fromPaginationResponse<T>(response: PageableResponse<T>): Page<T> {
    return new Page(
      response.content,
      response.totalElements,
      response.totalPages,
      response.number,
      response.size,
      response.first,
      response.last,
      response.empty
    )
  }

  public toPaginationState(): { first: number; rows: number } {
    return {
      first: this.number * this.size,
      rows: this.size
    };
  }
}
